import { Tabs } from "@mantine/core";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = location.pathname.endsWith("/users") ? "users" : "eventManagement";

  return (
    <div>
      <header>
        <h1>관리자</h1>
        <Tabs
          value={activeTab}
          onChange={(value) => value && navigate(`/admin/${value}`)}
          styles={{ tab: { color: "black" } }}
        >
          <Tabs.List>
            <Tabs.Tab value="eventManagement">이벤트 관리</Tabs.Tab>
            <Tabs.Tab value="users">사용자 관리</Tabs.Tab>
          </Tabs.List>
        </Tabs>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
